function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense, useCallback, useEffect, useRef, useState } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { Provider, useStore } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter, Routes, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { appHistory } from '@shared/routerHistory';
import { useHydration } from '@shared/hooks/useHydration';
import { ensureCheckoutApp } from '@shared/actions/thunkActions';
const Checkout = /*#__PURE__*/ React.lazy(()=>import('./checkout'));
/**
 * This component is in charge of hydrating only the PurchaseBlends Checkout wrapper by using React 17's hydrate function
 * on a pre-defined <div /> root because The PurchaseBlends UI does not support React 18.
 * @param _ props is never used
 * @param context React.context inherited by <AppView />
 * @returns JSX
 */ const LegacyCheckoutHydration = (_, context)=>{
    const checkoutDOMRef = useRef(null);
    const [contextValue] = useState(()=>{
        return _object_spread({}, context);
    });
    const isHydrated = useHydration();
    const store = useStore();
    const renderCheckout = useCallback(()=>{
        render(/*#__PURE__*/ _jsx(Provider, {
            store: store,
            children: /*#__PURE__*/ _jsx(HistoryRouter, {
                history: appHistory,
                children: /*#__PURE__*/ _jsx(Routes, {
                    children: /*#__PURE__*/ _jsx(Route, {
                        path: ":locale/marketplace/checkout/:entityId",
                        element: /*#__PURE__*/ _jsx(Suspense, {
                            fallback: null,
                            children: /*#__PURE__*/ _jsx(Checkout, {
                                context: contextValue
                            })
                        })
                    })
                })
            })
        }), checkoutDOMRef.current);
    }, [
        store,
        contextValue
    ]);
    useEffect(()=>{
        if (!isHydrated) {
            return;
        }
        const current = checkoutDOMRef.current;
        if (current && !current.children.length) {
            renderCheckout();
        }
        return ()=>{
            if (current) {
                unmountComponentAtNode(current);
            }
        };
    }, [
        checkoutDOMRef,
        renderCheckout,
        isHydrated
    ]);
    return /*#__PURE__*/ _jsx("div", {
        "data-react-legacy-root": "checkout",
        ref: checkoutDOMRef
    });
};
LegacyCheckoutHydration.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    locDateString: PropTypes.func,
    locale: PropTypes.string,
    buildHref: PropTypes.func,
    ctaCallback: PropTypes.func,
    contactCallback: PropTypes.func,
    openTileCallback: PropTypes.func,
    renderErrorModal: PropTypes.func,
    reportAbuseCallback: PropTypes.func,
    getAppHeaderHeight: PropTypes.func
};
export const ensureAsyncDataSSR = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*(dispatch, getState, params) {
        const { entityId } = params;
        yield dispatch(ensureCheckoutApp({
            entityId
        }));
    });
    return function ensureAsyncDataSSR(dispatch, getState, params) {
        return _ref.apply(this, arguments);
    };
}();
export default LegacyCheckoutHydration;
